import React from "react";
import "./Banner.css";
import axios from "axios";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import Banner_Card from "./Banner_Card/Banner_Card";
import RedRoundBtn from "../../Common_Component/Common_Btn/RedRoundBtn/RedRoundBtn";

function Banner() {

  const scrollToSection = (id, offset = 100) => {

    const section = document.getElementById(id);
    if (section) {
      const top = section.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <section className="Banner">
      <div className="container-fluid p-0">
        <Swiper
          spaceBetween={30}

          // loop={true}
          centeredSlides={true}
          pagination={{
            dynamicBullets: true,
            clickable: true,
          }}
          dots={true}
          modules={[Pagination]}
          // autoplay={{
          //   delay: 2000,
          //   disableOnInteraction: false,
          // }}
          className="mySwiper"
        >

          <SwiperSlide >
            <div className="banner_card">
              <div className="img_holder">
                <img src="\assets\Image\Home\Banner\banner1.png" className="banner_img" />
              </div>
              <div className="rigth_side">
                <div className="img_container">
                  <div className="img_holder">
                    <img src="\assets\Image\Home\Banner\right.png" className="img" />
                  </div>

                  <div className="btn_holder">
                    <RedRoundBtn btn_name="Get a Loan" onClick={() => scrollToSection("key_feature")} />
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide >
            <div className="banner_card">
              <div className="img_holder">
                <img src="\assets\Image\Home\Banner\banner1.png" className="banner_img" />
              </div>
              <div className="rigth_side">
                <div className="img_container">
                  <div className="img_holder">
                    <img src="\assets\Image\Home\Banner\right.png" className="img" />
                  </div>

                  <div className="btn_holder">
                    <RedRoundBtn btn_name="Get a Loan" onClick={() => scrollToSection("key_feature")} />
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>



        </Swiper>
      </div>
    </section>
  );
}

export default Banner;
